import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppSettings } from 'src/app/app-settings';
import { ApiBusinessService } from 'src/app/services/api-business.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PlacesService } from 'src/app/services/places.service';
import { PermissionService } from 'src/app/services/permission.service';
import { MODULE_CASH_REGISTER, MODULE_SEASON_PASSES, ModulesService } from 'src/app/services/modules.service';

@Component({
  selector: 'app-menu-panel',
  templateUrl: './menu-panel.component.html',
  styleUrls: ['./menu-panel.component.scss'],
})
export class MenuPanelComponent implements OnInit {
  @Input() itemActive = 1;
  @Input() hideDesktopNavigation: boolean = false;
  @Output() changeTab: EventEmitter<any> = new EventEmitter<any>();
  profile: any = this.auth.getProfile();
  urlImages: string = AppSettings.MEDIA_URI + '/users_images/';

  placeSelect!: any;
  placesUser!: Observable<any>;
  rolesUser!: Observable<any>;

  companySelect: any = {
    name: 'AYTO. MIRANDA DE EBRO',
    id: 1,
  };
  allBusiness!: any[];
  originalBusiness!: any[]; // Lista original del API
  places: any[] = [];
  rolesProfile: any[] = this.auth
    .getProfile()
    ?.roles.map((role: any) => role.name);
  admin: boolean = false;
  allowOrder: boolean = false;
  allowSales: boolean = false;
  allowMarketing: boolean = false;
  loadingPlaces: boolean = true;
  allowSuperAdmin: boolean = false;
  isMenuCollapsed: boolean = true;
  userMode: 'user' | 'organizer' = 'organizer';

  showVenueSubmenu: boolean = false;
  venueSubmenuCollapsed: boolean = true;
  venueId: number | null = null;
  venueMapVersion: boolean = false;
  isMapActive: boolean = false;

  showPermissionSubmenu: boolean = false;
  permissionRoles: any[] = [];
  currentPermissionRole: any = 'all';

  isOrgSubmenuExpanded: boolean = false;

  // Módulos contratados por la empresa (ver ModulesService)
  showSeasonPasses: boolean = true;
  showCashRegister: boolean = true;

  constructor(
    private router: Router,
    private auth: AuthenticationService,
    private placesServices: PlacesService,
    private apiBusiness: ApiBusinessService,
    private permissionService: PermissionService,
    private modulesService: ModulesService,
  ) {}

  toggleMenu(): void {
    this.isMenuCollapsed = !this.isMenuCollapsed;
  }

  ngOnInit(): void {
    this.profile = this.auth.getProfile();

    // Mantener el perfil (incluida la imagen) sincronizado con el servicio de autenticación
    this.auth.profileStorage.subscribe({
      next: (profile) => {
        if (profile) {
          this.profile = profile;
        }
      },
    });

    this.auth.userMode$.subscribe(mode => { this.userMode = mode; });

    this.modulesService.activeModules$.subscribe(() => {
      this.showSeasonPasses = this.modulesService.hasModule(MODULE_SEASON_PASSES);
      this.showCashRegister = this.modulesService.hasModule(MODULE_CASH_REGISTER);
    });
    this.allowSuperAdmin = this.rolesProfile?.find(
      (element) => element == 'superadmin',
    );

    this.apiBusiness.getCompanyByUser(this.profile?.id).subscribe({
      next: (res: any) => {
        this.loadingPlaces = true;
        this.originalBusiness = res.data.data; // Guardar la lista original
        this.allBusiness = [...this.originalBusiness]; // Crear copia

        // Obtener empresa del localStorage
        const storedBusiness = localStorage.getItem('business')
          ? JSON.parse(localStorage.getItem('business') || '{}')
          : null;

        // Si es superadmin y hay empresa en localStorage
        if (this.allowSuperAdmin && storedBusiness && storedBusiness.id) {
          // Si la empresa está en la lista, se usa esa entrada y no la guardada:
          // la recién traída lleva sus módulos (ver ModulesService). Si no está,
          // se agrega temporalmente la guardada.
          const existsInList = this.allBusiness.find(
            (b: any) => b.id === storedBusiness.id,
          );
          if (existsInList) {
            this.companySelect = existsInList;
          } else {
            this.companySelect = storedBusiness;
            this.allBusiness = [storedBusiness, ...this.originalBusiness];
          }
        } else {
          // Para usuarios normales, buscar en el array de empresas a las que tiene acceso
          let businessDefault = this.allBusiness[0];
          if (this.profile?.citylok) {
            let businessKreare = this.allBusiness.find(
              (value) => value.name == 'Kreare Digital SL',
            );
            if (businessKreare) {
              businessDefault = businessKreare;
            }
          }

          if (storedBusiness && storedBusiness.id) {
            const foundBusiness = this.allBusiness.find(
              (b: any) => b.id === storedBusiness.id,
            );
            this.companySelect = foundBusiness || businessDefault;
          } else {
            this.companySelect = businessDefault;
          }
        }

        if (this.companySelect) {
          this.placesUser = null;
          this.apiBusiness.setBusinessStorage(this.companySelect);
          this.getPlaces();
        }
      },
    });

    this.rolesProfile?.forEach((element) => {
      if (
        element == 'ACCESS_CLOUD' ||
        element == 'ACCOUNT_OWNER' ||
        element == 'ACCESS_EXTERN_EVENTS' ||
        element == 'ACCESS_ADMIN' ||
        element == 'ACCESS_MANAGER'
      ) {
        this.admin = true;
      }
      if (element == 'ACCESS_SALES') {
        this.allowSales = true;
      }
      if (
        element == 'ACCESS_SUPPORT' ||
        element == 'ACCESS_REPORTS' ||
        element == 'ACCESS_SALES'
      ) {
        this.allowOrder = true;
      }
      if (element == 'ACCESS_MARKETING' || element == 'ACCESS_SUPPORT') {
        this.allowMarketing = true;
      }
      if (element == 'admin' || element == 'superadmin') {
        this.admin = true;
      }
    });

    this.apiBusiness.businesSuperadmin.subscribe({
      next: (res) => {
        if (res && this.allowSuperAdmin && this.companySelect?.id != res.id) {
          this.changeBusinessEdit(res);
        }
      },
    });
  }

  ngAfterViewInit() {
    this.syncVenueSubmenuFromUrl(this.router.url);
    this.syncPermissionSubmenuFromUrl(this.router.url);
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.syncVenueSubmenuFromUrl(event.url);
        this.syncPermissionSubmenuFromUrl(event.url);
      }
    });
  }

  toggleOrgSubmenu() {
    this.isOrgSubmenuExpanded = !this.isOrgSubmenuExpanded;
  }

  private syncVenueSubmenuFromUrl(url: string) {
    const cleanUrl = (url || '').split('?')[0];
    const isVenueDetail = cleanUrl.includes('/panel-control/config/venues/') &&
      !cleanUrl.endsWith('/panel-control/config/venues');
    this.showVenueSubmenu = isVenueDetail;
    this.isMapActive = cleanUrl.includes('/map-venue/') || cleanUrl.includes('/create-map/');
    if (!isVenueDetail) { this.venueId = null; this.venueMapVersion = false; return; }
    const pathParts = cleanUrl.split('/');
    const possibleId = Number(pathParts[pathParts.length - 1]);
    const newVenueId = Number.isNaN(possibleId) ? null : possibleId;

    if (newVenueId === this.venueId) { return; }

    this.venueMapVersion = false;
    this.venueId = newVenueId;

    if (this.venueId) {
      this.placesServices.getPlaceById(this.venueId).subscribe({
        next: (res) => {
          this.venueMapVersion = !!(res?.data?.map || res?.data?.map_version);
        },
        error: () => { this.venueMapVersion = false; }
      });
    }
  }

  private syncPermissionSubmenuFromUrl(url: string) {
    const cleanUrl = (url || '').split('?')[0];
    this.showPermissionSubmenu = cleanUrl.includes('/config/permission');
    if (this.showPermissionSubmenu && this.permissionRoles.length === 0) {
      this.permissionService.getRolesFunctions().subscribe({
        next: (res: any) => { this.permissionRoles = res.data || []; }
      });
    }
    const params = new URLSearchParams(url.includes('?') ? url.split('?')[1] : '');
    this.currentPermissionRole = params.get('role') || 'all';
  }

  getPlaces() {
    if (this.allowSuperAdmin) {
      this.placesServices.getPlacesByCompany(this.companySelect?.id).subscribe({
        next: (res: any) => {
          this.places = res.data.data;
          this.loadingPlaces = false;
        },
      });
    } else {
      this.auth.getMyData().subscribe({
        next: (res: any) => {
          this.places = res.companies.flatMap((company: any) => company.spaces);

          // Obtener todas las funciones de todos los espacios sin duplicados
          const allFunctions = res.companies.flatMap(
            (company: any) => company.spaces,
          );
          this.loadingPlaces = false;

          if (this.places && this.places.length === 1) {
            this.placeSelect = this.places[0].id;
            this.changePlaceUser(); // Esto guarda en localStorage y notifica cambios
          }
        },
      });
    }

    this.placeSelect = localStorage.getItem('places')
      ? JSON.parse(localStorage.getItem('places'))
      : null;
    // Si no hay placeSelect guardado y hay lugares, seleccionar el primero por defecto
    /*if (!this.placeSelect && this.places && this.places.length > 0) {
      this.placeSelect = this.places[0].id;
      this.changePlaceUser();
    } */ if (this.placeSelect) {
      this.changePlaceUser();
    } else {
      this.apiBusiness.setChanges(this.companySelect);
    }
  }

  activeTab(tab: number, name: string) {
    this.itemActive = tab;
    this.changeTab.emit({ tab: tab, name: name });
  }

  changeBusinessEdit(business: any) {
    this.companySelect = business;
    localStorage.removeItem('places');
    this.apiBusiness.setBusinessStorage(business);

    // Para superadmin, reconstruir la lista con solo la empresa seleccionada si no está en la original
    if (this.allowSuperAdmin) {
      const existsInOriginal = this.originalBusiness.find(
        (b: any) => b.id === business.id,
      );
      if (!existsInOriginal) {
        // Solo mostrar la empresa seleccionada más la lista original
        this.allBusiness = [business, ...this.originalBusiness];
      } else {
        // Si está en la original, solo mostrar la lista original
        this.allBusiness = [...this.originalBusiness];
      }
    }

    this.getPlaces();
  }

  changePlaceUser() {
    this.apiBusiness.setPlaceStorage(this.placeSelect || null);
    let place = this.placeSelect ? this.placeSelect : 'place';
    this.apiBusiness.setChanges(place);
  }

  openTicketOffice() {
    if (!this.admin && !this.allowSales && !this.allowSuperAdmin) {
      return;
    }
    const token = localStorage.getItem('jwt_token');
    let business = JSON.parse(localStorage.getItem('business') || '{}');
    let id_business = business.id;
    const url = `${AppSettings.SALES}/login/${id_business}/${token}`;
    window.open(url, '_blank');
  }

  switchMode(mode: 'user' | 'organizer') {
    if (this.userMode === mode) return;
    this.auth.setUserMode(mode);
    this.router.navigate([mode === 'user' ? '/profile' : '/panel-control/events']);
  }

  goToUserProfile() {
    this.router.navigate(['/profile']);
  }

  goEditProfile() {
    this.router.navigate(['/panel-control/config/info-profile']);
  }

  logout() {
    this.auth.logout();
  }
}
